<template>
  <div>
    <!-- Average Rating Binding Component -->
    <AverageRating v-if="isAvgRatingBinding" />

    <!-- Review And Rating Binding Component -->
    <ResponsiveComponent v-else>
      <!-- Mobile View Only -->
      <template #mobile>
        <LayoutTwoMobile />
      </template>

      <!-- Desktop View Only -->
      <template #desktop>
        <LayoutTwoDesktop />
      </template>
    </ResponsiveComponent>
  </div>
</template>

<script>
  import ResponsiveComponent from "@/components/Utilities/ResponsiveComponent/ResponsiveComponent.vue"
  import LayoutTwoMobile from "./LayoutTwoMobile.vue"
  import LayoutTwoDesktop from "./LayoutTwoDesktop.vue"
  import AverageRating from "@/components/ReviewAndRating/AverageRating/AverageRating.two.vue"
  import { BINDING_TYPE } from "@/constants/constants"

  export default {
    name: "LayoutOne",
    components: {
      AverageRating,
      ResponsiveComponent,
      LayoutTwoDesktop,
      LayoutTwoMobile,
    },
    props: {
      bindingType: {
        type: String,
        default: "",
      },
    },
    computed: {
      isAvgRatingBinding() {
        return this.bindingType === BINDING_TYPE.AVERAGE_RATING
      },
    },
  }
</script>
